module.exports = __webpack_public_path__ + "img/nhs-logo.144e07eb.svg";